import { render, staticRenderFns } from "./ProductAvailability.vue?vue&type=template&id=49f2ae93&scoped=true"
import script from "./ProductAvailability.vue?vue&type=script&lang=js"
export * from "./ProductAvailability.vue?vue&type=script&lang=js"
import style0 from "./ProductAvailability.vue?vue&type=style&index=0&id=49f2ae93&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f2ae93",
  null
  
)

export default component.exports